module.exports = __webpack_public_path__ + "img/arrow__down__green.21e47f75.svg";